import { gql } from '@apollo/client';

export const GET_COUNTRIES_QUERY = gql`
  query getCountriesQuery($master_list: Boolean, $group_id: String, $company_id: String) {
    countries(master_list: $master_list, group_id: $group_id, company_id: $company_id) {
      id
      deleted
      code
      name
      continent
      phone_code
      phone_regex
      reference {
        id
        path
        parentPath
      }
    }
  }
`;
